import _ from 'lodash';
import { DB_NAME, DEV_MODE } from '../Constants';

type LocalSelector = (state: any, ...args: any[]) => any;
type SelectorMap = Record<string, LocalSelector>;
type SelectorState<T extends LocalSelector> = T extends (
  state: infer State,
  ...args: any[]
) => any
  ? State
  : never;
type MountedSelectorState<MountPath extends string, LocalState> = {
  [K in MountPath]: LocalState;
};
type GlobalizedSelectors<T extends SelectorMap, MountPath extends string> = {
  [K in keyof T]: T[K] extends (state: any, ...args: infer Args) => infer Return
    ? (
        state: MountedSelectorState<MountPath, SelectorState<T[K]>>,
        ...args: Args
      ) => Return
    : never;
};

export function globalizeSelectors<
  T extends SelectorMap,
  MountPath extends string,
>(selectors: T, mountPath: MountPath): GlobalizedSelectors<T, MountPath> {
  const result = {} as GlobalizedSelectors<T, MountPath>;

  for (const funcName of Object.keys(selectors) as Array<keyof T>) {
    const func = selectors[funcName];
    result[funcName] = ((state: unknown, ...args: unknown[]) =>
      func(_.get(state, mountPath), ...args)) as GlobalizedSelectors<
      T,
      MountPath
    >[typeof funcName];
  }
  return result;
}

export function handle_db_name(url: string): string {
  // Adds database name to query URL
  const db_url = DB_NAME ? `/db/${DB_NAME}${url}` : url;
  return DEV_MODE ? `/dev_api${db_url}` : db_url;
}
